import { render, staticRenderFns } from "./ConnectArtistToReleaseDialog.vue?vue&type=template&id=68d3144a"
import script from "./ConnectArtistToReleaseDialog.vue?vue&type=script&lang=js"
export * from "./ConnectArtistToReleaseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports